import type { PropertyIn, PropertyPath } from '@/scopes/common/domain/types'
import type { FilterOptions, QuickSearchFilters } from '@/scopes/search/quick-search/domain/types'
import type { StoreApi } from 'zustand'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { createStore } from 'zustand'

export interface QuickSearchState {
  searchLink: string
  totalResults: number
  filterOptions: Partial<FilterOptions>
  getQuickSearch: {
    loading: boolean
    error: boolean
  }
  publicationCode: string
  contextItemId: string
  filterSelection: QuickSearchFilters
}

type QuickSearchStatePath = PropertyPath<QuickSearchState>

export interface QuickSearchStoreActions {
  setIn: (path: QuickSearchStatePath, value: PropertyIn<QuickSearchState, typeof path>) => void
}

const initialState = {
  searchLink: '',
  totalResults: 0,
  filterOptions: {},
  getQuickSearch: {
    loading: true,
    error: false,
  },
  publicationCode: '',
  contextItemId: '',
  filterSelection: {},
}

export type QuickSearchStore = QuickSearchState & QuickSearchStoreActions
export type QuickSearchStoreApi = Pick<StoreApi<QuickSearchStore>, 'getState'>

export function createQuickSearchStore(initState: QuickSearchState): StoreApi<QuickSearchStore> {
  return createStore<QuickSearchStore>(set => ({
    ...initState,
    setIn: (path, value) => {
      set(state => setIn(state, path, value) as QuickSearchState)
    },
  }))
}

export const quickSearchStore = createQuickSearchStore(initialState)
